import angular from 'angular';
import 'angular-ui-router';
import 'angular-cookies';
import { BotConnectComponent } from './botConnect/botConnect.component';
import BusinessLoginController from './BusinessLoginController';
import BusinessLoginView from './BusinessLoginView.html';
//
export default angular
    .module('businessLogin', ['shared'])
    .component('botConnect', BotConnectComponent)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('auth.businesschat', {
            url: '/businesschat',
            views: {
                '@': {
                    controller: BusinessLoginController,
                    controllerAs: '$ctrl',
                    template: BusinessLoginView,
                },
            },
        });
    }]).name;
